import { z } from 'zod';
import { SchemaDate } from '@axiom/types';

import { ExperienceSchema } from './experience';

const GroupedExperienceSchema = ExperienceSchema.extend({
  isHighlighted: z.boolean().nullable().default(false),
});

export const GroupedExperiencesSchema = z.object({
  candidateId: z.string().uuid(),
  isAxiom: z.boolean(),
  endDate: SchemaDate,
  startDate: SchemaDate,
  experiences: z.array(GroupedExperienceSchema),
});

export type GroupedExperience = z.infer<typeof GroupedExperienceSchema>;
export type GroupedExperiences = z.infer<typeof GroupedExperiencesSchema>;
